/**
 * HttpRequest : hitting request on config url with headers, body etc
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 * @param options object
 * @param callback function
 */
const HttpRequest = (options, callback) => {
    options["headers"]['X-Requested-With'] = 'XMLHttpRequest';
    if(!("x-tenant-id" in options.headers) && tenant_id){
        options["headers"]["x-tenant-id"] = tenant_id;
    }    
    Object.assign(options, {
        async: true,
        crossDomain: true
    });
    $.ajax(options).done((response) => {
        callback(response);
    }).fail(error => {
        callback(null, error)
    });
};
